import config from "../config";
import { authHeader } from "../helpers";

const login = (email, password, platform) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password, platform }),
  };

  return fetch(`${config.authApiUrl}/auth/login`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      if (user) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(user));
        return user;
      }
    });
};

const checkAuthUser = (token) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(`${config.authApiUrl}/auth`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      if (user) {
        let userName = user?.resource?.name;
        if (user?.resource?.lastName != null) {
          userName += ` ${user?.resource?.lastName}`;
        }
        let finalUser = {
          email: user.email,
          message: "Authentication successful",
          name: userName,
          token: token,
          userId: user.id,
          userRole: user?.role > 4 ? 4: user?.role,
        };
        localStorage.setItem("user", JSON.stringify(finalUser));
        return finalUser;
      }
    });
};

const logout = () => {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
  localStorage.removeItem("domain");
  localStorage.removeItem("google-token")
};

//const send forgot mail
const sendMail = (email, host) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, host }),
  };

  return fetch(`${config.authApiUrl}/auth/forgetPassword?platform=ats`, requestOptions).then(
    handleResponse
  );
};

const checkLogin = () => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return fetch(
    `${config.authApiUrl}/auth/login/check-token`,
    requestOptions
  ).then(handleResponse);
};

const getValidateToken = (token) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return fetch(
    `${config.authApiUrl}/auth/validate-token/${token}`,
    requestOptions
  ).then(handleResponse);
};

const ChangePassword = (password, confirmPassword, token) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password, confirmPassword }),
  };

  return fetch(
    `${config.authApiUrl}/auth/change-password/${token}`,
    requestOptions
  ).then(handleResponse);
};

const handleResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

const getProfile = () => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return fetch(
    `${config.authApiUrl}/auth?platform=ats`,
    requestOptions
  ).then(handleResponse);
};

const updateProfile = (createData) => {
  const formData = new FormData();

  for (const name in createData) {
    formData.append(name, createData[name]);
  }
  const requestOptions = {
    method: "PUT",
    headers: {
      ...authHeader(),
    },
    body: formData,
  };

  return fetch(`${config.authApiUrl}/auth/editUserProfile`, requestOptions).then(
    handleResponse
  );

}

export const authService = {
  login,
  logout,
  sendMail,
  getValidateToken,
  ChangePassword,
  checkAuthUser,
  checkLogin,
  getProfile,
  updateProfile
};
